import { render } from "./DeleteProject.vue?vue&type=template&id=33b291f4"
import script from "./DeleteProject.vue?vue&type=script&lang=js"
export * from "./DeleteProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__